import(/* webpackMode: "eager" */ "/codebuild/output/src156271393/src/apps/jumplab/src/app/error.tsx");
